import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-estadisticas',
  templateUrl: './estadisticas.component.html',
  styleUrls: ['./estadisticas.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class EstadisticasComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
